import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import useProducts from "../../hooks/useProducts";
import useAuth from "../../hooks/useAuth";
import Navigation from "../Shared/Navigation/Navigation";
import Footer from "../Shared/Footer/Footer";
import { createBooking } from "../../service/bookingService";

const BookProducts = () => {
  const { productId } = useParams();
  const [products] = useProducts();
  const [productDetails, setProductDetails] = useState({});
  const { user } = useAuth();
  const navigate = useNavigate();
  const redirectUri = "/dashboard";

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    const selectedProduct = products.find(
      (product) => product._id === productId
    );
    setProductDetails(selectedProduct);
  }, [productId, products]);

  const onSubmit = async (data) => {
    data.status = "Pending";
    try {
      await createBooking(data);
      alert("Booked Successfully!");
      reset();
      navigate(redirectUri);
    } catch (err) {
      console.error("Booking failed:", err);
      alert("Something went wrong. Please try again.");
    }
  };

  return (
    <>
      <Navigation />
      <div className="min-h-screen bg-gray-50">
        <div className="max-w-5xl mx-auto px-6 py-16">
          <h2 className="text-3xl font-bold text-slate-900 text-center mb-10">
            Confirm Your Order
          </h2>
          <div className="flex flex-col md:flex-row gap-10 items-start">
            {/* Pet Preview Card */}
            <div className="w-full md:w-5/12">
              <div className="bg-white rounded-2xl shadow-md overflow-hidden">
                <div className="relative">
                  <img
                    className="w-full h-56 object-cover"
                    src={productDetails?.img}
                    alt={productDetails?.title}
                  />
                  <span className="absolute top-3 left-3 bg-amber-400 text-slate-900 text-xs font-bold px-3 py-1 rounded-full">
                    {productDetails?.price}
                  </span>
                </div>
                <div className="p-5">
                  <h3 className="text-lg font-bold text-slate-900">
                    {productDetails?.title}
                  </h3>
                  <p className="text-xs text-slate-500 mt-1 mb-2">
                    <span className="font-semibold">Size:</span>{" "}
                    {productDetails?.size}
                  </p>
                  <p className="text-sm text-slate-600 leading-relaxed line-clamp-4">
                    {productDetails?.details}
                  </p>
                </div>
              </div>
            </div>

            {/* Booking Form */}
            <div className="w-full md:w-7/12 bg-white rounded-2xl shadow-md p-8">
              <h3 className="text-lg font-semibold text-slate-800 mb-6">
                Booking Details
              </h3>
              <form onSubmit={handleSubmit(onSubmit)} className="space-y-5">
                {productDetails?.title && (
                  <div>
                    <label className="block text-xs font-medium text-slate-500 mb-1">
                      Pet
                    </label>
                    <input
                      {...register("title")}
                      defaultValue={productDetails?.title}
                      readOnly
                      className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-slate-700 text-sm focus:outline-none"
                    />
                  </div>
                )}
                <div>
                  <label className="block text-xs font-medium text-slate-500 mb-1">
                    Your Name
                  </label>
                  <input
                    {...register("name")}
                    defaultValue={user?.displayName}
                    readOnly
                    className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-slate-700 text-sm focus:outline-none"
                  />
                </div>
                <div>
                  <label className="block text-xs font-medium text-slate-500 mb-1">
                    Your Email
                  </label>
                  <input
                    {...register("email")}
                    defaultValue={user?.email}
                    readOnly
                    className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-slate-700 text-sm focus:outline-none"
                  />
                </div>
                {productDetails?.price && (
                  <div>
                    <label className="block text-xs font-medium text-slate-500 mb-1">
                      Price
                    </label>
                    <input
                      {...register("price")}
                      defaultValue={productDetails?.price}
                      readOnly
                      className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-slate-700 text-sm focus:outline-none"
                    />
                  </div>
                )}
                <div>
                  <label className="block text-xs font-medium text-slate-500 mb-1">
                    Delivery Address
                    <span className="text-red-500 ml-1">*</span>
                  </label>
                  <input
                    {...register("address", { required: true })}
                    type="text"
                    placeholder="Enter your delivery address"
                    className="w-full px-4 py-3 border border-gray-200 rounded-xl text-slate-700 text-sm focus:outline-none focus:ring-2 focus:ring-amber-400 focus:border-transparent transition"
                  />
                  {errors.address && (
                    <p className="text-red-500 text-xs mt-1">
                      Address is required
                    </p>
                  )}
                </div>
                <button
                  type="submit"
                  className="w-full py-3 bg-slate-900 text-white font-semibold rounded-full hover:bg-amber-500 hover:text-slate-900 transition-all duration-300 mt-2"
                >
                  Confirm Booking
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default BookProducts;
